<template>
	
	<div class="container page">
		
		<div class="header">
			
			<div class="nav-bar van-nav-bar van-hairline--bottom">
				<div class="van-nav-bar__content">
					<div class="van-nav-bar__left" @click="back()">
						<i class="van-icon van-icon-arrow-left" style="color: rgb(255, 255, 255);"></i>
					</div>
					<div class="van-nav-bar__title van-ellipsis">{{$t('my.grcs')}}</div>
				</div>
			</div>
			
			<div class="info">
				<p class="title">{{$t("withdraw.t1")}}({{$t("withdraw.t2")}})</p>
				<p class="value">{{ userInfo.money }}</p>
				<p class="tip">{{$t("withdraw.t3")}}:{{$t("withdraw.t4")}} - {{$t("withdraw.t5")}}</p>
			</div>
			
			<div class="content">
				<div class="datalist">
					<div class="datalistitem">
						<div class="datalistitemValue">{{ this.userInfo.money }}</div>
						<div class="datalistitemKey">{{$t("withdraw.t6")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ this.userInfo.recharge}}</div>
						<div class="datalistitemKey">{{$t("withdraw.t7")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ this.userInfo.withdraw }}</div>
						<div class="datalistitemKey">{{$t("withdraw.t8")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ this.userInfo.game }}</div>
						<div class="datalistitemKey">{{$t("withdraw.t9")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
				</div>
			</div>
					
			
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				win_money: 0,
				userInfo:{}
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			getUserInfo() {
				this.$http({
					method: "get",
					url: "user_info",
				}).then((res) => {
					if (res.code === 200) {
						this.userInfo = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../assets/css/base.css";

	.nav-bar {
		background: none;
	}

	.container.page {
		min-height: 100%;
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
	}

	.container .header {
		min-height: 100%;
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
		display: flex;
		flex-direction: column;
	}

	.container .header .info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 10px 20px 20px;
		padding: 28px 20px;
		border-radius: 18px;
		background: rgba(255, 255, 255, 0.14);
		box-shadow: 0 10px 28px rgba(0, 0, 0, 0.16);
		border: 1px solid rgba(255, 255, 255, 0.18);
	}

	.container .header .info .title {
		font-size: 25px;
		color: #e5e5e5;
	}

	.container .header .info .value {
		margin: 10px auto;
		color: #fff;
		font-size: 50px;
		border-bottom: 1px solid #fff;
	}

	.container .header .info .tip {
		font-size: 30px;
		color: #e5e5e5;
	}

	.container .content {
		flex: 1;
		background: transparent;
		margin: 0 20px 24px;
		padding: 16px 12px 40px;
		border-radius: 0;
		box-shadow: none;
	}

	.container .content .datalist {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		justify-content: flex-start;
		gap: 16px 0;
	}

	.container .content .datalist .datalistitem {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 26.667vw;
		width: calc(50% - 12px);
		margin: 0 6px;
		background: #fff;
		border-radius: 16px;
		box-shadow: 0 10px 28px rgba(79, 43, 138, 0.22), 0 4px 12px rgba(0, 0, 0, 0.12);
	}

	.container .content .datalist .datalistitem .datalistitemValue {
		color: #ff253f;
		font-size: 35px;
		margin-bottom: 10px;
		margin-top: 10px;
	}

	.container .content .datalist .datalistitem .datalistitemKey {
		color: #979799;
		font-size: 25px;
		margin-bottom: 10px;
		margin-top: 10px;
	}
</style>